import React from 'react'
import PropTypes from 'prop-types'
import { useStatusReportContext } from './statusReportContext'
import ItemStatusEditor from './ItemStatusEditor'
import { useFindItemInTree, useStatusInfo } from './hooks'
import StatusReportItemTitle from './StatusReportItemTitle'

function StatusReportCommentTitle ({ item, parent, statuses }) {
  const { report, isFetching } = useStatusReportContext()

  const theItem = useFindItemInTree(report?.items ?? [], item.statusReportItemId)
  const statusInfo = useStatusInfo(theItem?.status, statuses)

  if (!theItem) return null

  return (
    <>
      <StatusReportItemTitle statusInfo={statusInfo} item={theItem} parent={parent} />
      <ItemStatusEditor
        statusInfo={statusInfo}
        item={theItem}
        statuses={statuses}
        isFetching={isFetching}
        reportStatus={report?.status}
      />
    </>
  )
}

StatusReportCommentTitle.propTypes = {
  item: PropTypes.shape({
    statusReportItemId: PropTypes.number,
    optionLabel: PropTypes.string
  }),
  parent: PropTypes.any,
  statuses: PropTypes.array
}

export default StatusReportCommentTitle
